<template>
    <div class="mt20 ovh" style="word-break: break-all;">
        <el-table :data="brandList" style="width: 100%" border>
            <el-table-column prop="agreementCode" label="品牌品类申请编号" min-width="220" align="center">
            </el-table-column>
            <el-table-column prop="parentBrandAgreementCode" label="原品牌品类编号" min-width="220" align="center">
            </el-table-column>
            <!--<el-table-column prop="supplierCode" label="供应商编号" min-width="220" align="center">
            </el-table-column>
            <el-table-column prop="supplierName" label="供应商名称" min-width="220" align="center">
            </el-table-column>-->
            <el-table-column prop="contractCode" label="合同编号" min-width="220" align="center">
            </el-table-column>
            <el-table-column label="合作期限" min-width="220" align="center">
                <template scope="scope">
                    {{scope.row.startTime | datetimes}} - {{scope.row.endTime | datetimes}}
                </template>
            </el-table-column>
            <el-table-column prop="statusDesc" label="合作状态" min-width="220" align="center">
            </el-table-column>
            <el-table-column prop="typeDesc" label="申请类型" min-width="220" align="center">
            </el-table-column>
            <el-table-column label="操作" width="100" align="center" fixed="right">
                <template scope="scope">
                    <router-link :to="scope.row.type==2 ? '/supplierBrandAgreement?agreementId=' + scope.row.agreementId : (scope.row.type==3 ? '/supplierBrandSupplement?agreementId=' + scope.row.agreementId : '')">
                        <el-button type="text" size="small">
                            查看详情
                        </el-button>
                    </router-link>

                    <span><!--有用的空标签--></span>
                    <el-button v-if="editAuth && (scope.row.status == 1 || scope.row.status == 4)" @click="endBrandAgreement(scope.row.agreementId, scope.row.type)" type="text" size="small">
                        终止合作
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                suppliersId: 0,
                brandList: [],
                editAuth: false
            };
        },
        methods: {
            initBrandList(suppliersId){
                var that = this;
                $.get({
                    url: '/suppliers/brandAgreement/brandAgreements/find',
                    data: {
                        supplierId: suppliersId
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.brandList = result.data.list;
                        } else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            getUserAuth(){
                var that = this;
                $.get({
                    url: '/suppliers/brandAgreement/auth/find',
                    data: {
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.editAuth = result.data.edit;
                        } else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            endBrandAgreement(agreementId, type){
                var that = this;
                that.$confirm('此操作将终止协议, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var Data = {};
                    Data.brandAgreementId = agreementId;
                    Data.type = type;
                    $.ajax({
                        url: '/suppliers/brandAgreement/brandAgreement/end',
                        data: JSON.stringify(Data),
                        dataType: "json",
                        contentType: 'application/json;charset=utf-8',
                        type: 'POST',
                        success: function (result) {
                            if (!result.code) {
                                that.initBrandList(that.suppliersId);
                            } else {
                                that.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消终止'
                    });
                });
            }
        },

        mounted () {
            var suppliersId = this.$route.query.suppliersId;
            this.suppliersId = suppliersId;
            this.$nextTick(function () {
                this.initBrandList(suppliersId);
                this.getUserAuth();
            })
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .min_height {
        min-height: 300px;
    }
</style>


// WEBPACK FOOTER //
// brandList.vue?8e392c2c